// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__D60y4","col":"Table_col__c9oP-","fulfillmentStatus":"Table_fulfillmentStatus__2XWZv","emailCol":"Table_emailCol__16Glu"};